import FootballDraw from './football/draw';
import FootballGame from './football/game';
import FootballLose from './football/lose';
import FootballRanking from './football/ranking';
import FootballWin from './football/win';
import GeneralDraw from './general/draw';
import GeneralGame from './general/game';
import GeneralLose from './general/lose';
import GeneralRanking from './general/ranking';
import GeneralWin from './general/win';
import { SportType } from './types';

const Regulations = (props?: { sportType?: SportType }) => {
  const { sportType } = props || {};

  const renderRuleComponents = () => {
    switch (sportType) {
      case 'football':
        return {
          Win: FootballWin,
          Lose: FootballLose,
          Draw: FootballDraw,
          Game: FootballGame,
          Ranking: FootballRanking,
        };
      case 'general':
      default:
        return {
          Win: GeneralWin,
          Lose: GeneralLose,
          Draw: GeneralDraw,
          Game: GeneralGame,
          Ranking: GeneralRanking,
        };
    }
  };

  const { Win, Lose, Draw, Game, Ranking } = renderRuleComponents();

  return (
    <>
      <div className="grid grid-cols-12 gap-6 mt-5">
        <div className="col-span-5">
          <div className="border border-surfacePlatinum20 rounded-lg h-full p-4">
            <Win />
          </div>
        </div>
        <div className="col-span-5">
          <div className="border border-surfacePlatinum20 rounded-lg h-full p-4">
            <Lose />
          </div>
        </div>
        <div className="col-span-2">
          <div className="border border-surfacePlatinum20 rounded-lg h-full p-4">
            <Draw />
          </div>
        </div>
        <div className="col-span-10">
          <div className="border border-surfacePlatinum20 rounded-lg h-full p-4">
            <Game />
          </div>
        </div>
        <div className="col-span-7">
          <div className="border border-surfacePlatinum20 rounded-lg h-full p-4">
            <Ranking />
          </div>
        </div>
      </div>
    </>
  );
};

export default Regulations;
